import React from 'react'
import { Loader } from '../../Loader'

import { Container } from '../styledComponents'

function FullScreenLoader() {
   return (
      <Container>
         <LoadingView />
      </Container>
   )
}
function LoadingView() {
   return <Loader height={30} width={30} />
}

export { LoadingView as default, FullScreenLoader }
